import UserIcon from '@assets/CustomIcons/user_edited.svg'
import ModelGenIcon from '@assets/Logos/model-generated-icon.svg'
import { BBDTag } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import React from 'react'

export const SupplyHistoryStatus = (props) => {
  const data = props.data
  const isSystem = data.run_by === 'system'

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Tooltip title={isSystem ? 'Gravitate' : data.run_by}>
        <img src={isSystem ? ModelGenIcon : UserIcon} style={{ width: 24, height: 24 }} />
      </Tooltip>
      <BBDTag
        error={['Failed', 'Error'].includes(data.status)}
        success={['Success', 'Complete'].includes(data.status)}
        theme2={data.status === 'Running'}
      >
        {data.status}
      </BBDTag>
    </div>
  )
}
